import {
  DateInput,
  DateInputProps,
  DateTimeInput,
  DateTimeInputProps,
  TimeInput,
  TimeInputProps,
} from '@react-admin/ra-form-layout'
import { isRequired } from 'react-admin'

const getSlotProps = (required?: boolean) => ({
  field: { clearable: !required },
  textField: { InputProps: { sx: { '& .MuiInputAdornment-root': { marginLeft: 0 } } } },
})

export const AdvancedDateInput = ({ validate, ...props }: DateInputProps) => {
  return (
    <DateInput
      slotProps={getSlotProps(isRequired(validate))}
      validate={validate}
      variant="outlined"
      parse={(value) => {
        if (!value) return null
        if (!(value instanceof Date)) return null
        if (Number.isNaN(value.getTime())) return null
        const utc = new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate()))
        return utc.toISOString()
      }}
      {...props}
    />
  )
}

export const AdvancedTimeInput = ({ validate, ...props }: TimeInputProps) => {
  return <TimeInput slotProps={getSlotProps(isRequired(validate))} validate={validate} variant="outlined" {...props} />
}

export const AdvancedDateTimeInput = ({ validate, ...props }: DateTimeInputProps) => {
  return (
    <DateTimeInput slotProps={getSlotProps(isRequired(validate))} validate={validate} variant="outlined" {...props} />
  )
}
